























import { computed, defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import BaseAvatar from "@/components/BaseAvatar";

type AvatarGroupUser = UserPublicData | null;

export default defineComponent({
  name: "AvatarsGroup",
  components: { BaseAvatar },
  props: {
    users: { type: Array as () => AvatarGroupUser[], required: true },
    maxUsers: { type: Number, default: 3 },
    size: { type: [Number, String], default: 112 },
    reverse: { type: Boolean, default: false },
    // Visible part of each avatar (0-1): 0 = fully stacked, 1 = side-by-side
    visibleFraction: { type: Number, default: 0.5 },
    whiteBorder: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    showOverflow: { type: Boolean, default: false },
  },
  setup(props) {
    const sizePx = computed(() => (typeof props.size === "string" ? parseFloat(props.size) : props.size));

    const hasOverflow = computed(() => props.showOverflow && props.users.length > props.maxUsers);

    const usersForDisplay = computed(() => {
      const limit = hasOverflow.value ? props.maxUsers - 1 : props.maxUsers;
      const sliced = props.users.slice(0, limit);
      return props.reverse ? sliced.reverse() : sliced;
    });

    const overlapPx = computed(() => Math.round(sizePx.value * (1 - props.visibleFraction)));

    const overflowCount = computed(() => {
      if (!hasOverflow.value) return 0;
      return props.users.length - (props.maxUsers - 1);
    });

    const overflowStyle = computed(() => ({
      width: sizePx.value + "px",
      height: sizePx.value + "px",
      fontSize: sizePx.value / 2 + "px",
    }));

    return { usersForDisplay, overlapPx, overflowCount, overflowStyle };
  },
});
